import { getStreamerProfileUrl } from './get-streamer-page-url';

export type StreamerSongsUrlParams = {
  platform: string | null | undefined;
  username: string | null | undefined;
  // search pre-filters the streamer's list, so a viewer who arrived from a
  // cross-streamer search lands on the song they were looking for rather than
  // at the top of a list of thousands.
  search?: string;
};

// getStreamerSongsUrl links to a streamer's song list, or returns null when
// there is no username to link to at all.
export function getStreamerSongsUrl({
  platform,
  username,
  search,
}: StreamerSongsUrlParams): string | null {
  const page = getStreamerProfileUrl({ platform, username });
  if (!page) return null;

  const query = search ? `?search=${encodeURIComponent(search)}` : '';

  return `${page}/songs${query}`;
}
